import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#00A4E0',
      dark: '#1B2B3A',
      light: '#33B5E6',
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: '#B4E33D',
      light: '#C5E964',
      dark: '#9BC535',
      contrastText: '#1B2B3A'
    },
    background: {
      default: '#1B2B3A',
      paper: '#243B53'
    },
    text: {
      primary: '#FFFFFF',
      secondary: 'rgba(255, 255, 255, 0.7)'
    }
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#243B53',
            '&:hover': {
              backgroundColor: '#2A4359'
            },
            '&.Mui-focused': {
              backgroundColor: '#2A4359'
            }
          }
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          backgroundColor: '#243B53',
          '&:hover': {
            backgroundColor: '#2A4359'
          },
          '&.Mui-focused': {
            backgroundColor: '#2A4359'
          }
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: '#2A4359'
          },
          '&.Mui-selected': {
            backgroundColor: '#1B2B3A',
            '&:hover': {
              backgroundColor: '#243B53'
            }
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          textTransform: 'none'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none'
        }
      }
    }
  }
});
